export default {
  primary: "#09c",
  green: "#66cc66",
  success: "#66cc66",
  error: "#C64235",
  black: "#000"
} as { [index: string]: string };
